// Compat: as páginas continuam a fazer `const { success, error } = useToast()`.
// Agora tudo passa pelo contexto global (ToastProvider), por isso os toasts
// aparecem sempre — independentemente da página que os dispara.
import { useToastContext } from '../context/ToastContext';

export const useToast = () => useToastContext();
